export default __webpack_public_path__ + "images/bgpk6.548b91a.jpg";